import { useCallback } from "react";
import { create } from "zustand";

const useQRFormStore = create((set) => ({
  companySuggestions: [],
  selectedCompany: {},
  QRCodeUrl: "",
  companyName: "",
  type: "review",
  setState: (key, value) => set((state) => ({ ...state, [key]: value })),
}));

export default function useQR() {
  const { setState, ...restState } = useQRFormStore();

  const setStateCallback = useCallback((key, value) => setState(key, value), [setState]);

  return { setState: setStateCallback, ...restState };
}
